import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";
import * as CarriageCstic from "./KWLTCarriageCstics";

export const KWLTCarriagesDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  [CarriageCstic.Coating]: "NONE",
  [CarriageCstic.Accuracy]: "G4",
  [CarriageCstic.Preload]: "V0",
  [CarriageCstic.LocatingFace]: "O",
  [CarriageCstic.GreasingPerGreaseGroup]: "STD",
  [CarriageCstic.KitsLeft]: "100",
  [CarriageCstic.KitsRight]: "100",
  [CarriageCstic.KitsCenter]: "910",
  [CarriageCstic.LubricationConnectorOrientation]: "BL",
  [CarriageCstic.LubricationConnector]: "S505",
};
